import React from "react";
import {
  Container,
  Header,
  SpaceBetween,
  Box,
} from "@cloudscape-design/components";
import { QUICKSIGHT_DASHBOARD_CONFIG } from "./dashboardConfig";

const MonitorAlert: React.FC = () => {
  return (
    <Container
      header={
        <Header
          variant="h1"
          description={QUICKSIGHT_DASHBOARD_CONFIG.description}
        >
          {QUICKSIGHT_DASHBOARD_CONFIG.title}
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        {/* QuickSight Dashboard Embedded via iframe */}
        <Box>
          <style>
            {`
              .dashboard-iframe-container {
                width: 100%;
                min-height: ${QUICKSIGHT_DASHBOARD_CONFIG.iframeSettings.height};
                border-radius: 8px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                overflow: hidden;
                background: #ffffff;
              }
              .dashboard-iframe {
                width: 100%;
                height: ${QUICKSIGHT_DASHBOARD_CONFIG.iframeSettings.height};
                border: none;
                display: block;
              }
              .dashboard-loading {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 600px;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white;
                font-size: 18px;
              }
            `}
          </style>
          <div className="dashboard-iframe-container">
            <iframe
              src={QUICKSIGHT_DASHBOARD_CONFIG.dashboardUrl}
              className="dashboard-iframe"
              title="QuickSight Dashboard"
              width={QUICKSIGHT_DASHBOARD_CONFIG.iframeSettings.width}
              height={QUICKSIGHT_DASHBOARD_CONFIG.iframeSettings.height}
              frameBorder={
                QUICKSIGHT_DASHBOARD_CONFIG.iframeSettings.frameBorder
              }
              allowFullScreen={
                QUICKSIGHT_DASHBOARD_CONFIG.iframeSettings.allowFullScreen
              }
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          </div>
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default MonitorAlert;
